import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Button, Card, Row, Spinner, Space } from "@masterteam/mt-design-react";
import Item from "./Item";

import "./style.scss";

function CardList({
  data = [],
  nameKey,
  valueKey,
  onClickItem,
  selectedItem,
  title,
  headerActions,
  actions,
  isLoading,
  animation = "fadeInLeft",
  showStrategyIcon = false,
}) {
  return (
    <Card className={`card-list3 animated ${animation}`}>
      <Row size="small" justify="between" align="center" className="header-box">
        <div className="title">{title}</div>
        {headerActions?.length ? (
          <Space>
            {headerActions.map((action) => {
              if (typeof action === "function") return action();
              return <Button {...action}>{action.label}</Button>;
            })}
          </Space>
        ) : null}
      </Row>
      <div style={{ height: 450, overflowY: "auto" }} id="custom-scroll">
        {isLoading ? (
          <Row justify="center" align="center" style={{ height: "100%" }}>
            <Spinner />
          </Row>
        ) : (
          <ul className="list-group section-preview scroll animated fadeIn">
            {data.map((item, index) => (
              <Item
                key={item[valueKey]}
                item={item}
                nameKey={nameKey}
                isSelected={item[valueKey] === selectedItem}
                isLast={index !== 0 && index === data.length - 1}
                onClick={
                  onClickItem ? () => onClickItem(item, index) : undefined
                }
                actions={actions}
                showStrategyIcon={showStrategyIcon}
              />
            ))}
          </ul>
        )}
      </div>
    </Card>
  );
}

export default CardList;
